
import CadminBankAccountsAx from 'app/actions/company-admin/bank-accounts';
import CadminCompaniesAx    from 'app/actions/company-admin/companies';
import CadminCreditCardsAx  from 'app/actions/company-admin/credit-cards';
import CadminWalletAx       from 'app/actions/company-admin/wallet';
import ToastAx              from 'app/actions/toast';
import {
  PaymentMethodTypes,
}                           from 'app/constants';
import CadminSlx            from 'app/selectors/company-admin/';
import PageSlx              from 'app/selectors/company-admin/page-wallet';
import RoutingSlx           from 'app/selectors/routing';

const Types = {
  LOAD: 'CADMIN_PAGE_WALLET_LOAD',
  LOAD_PAGE_UPCOMING_CHARGES: 'CADMIN_PAGE_WALLET_LOAD_PAGE_UPCOMING_CHARGES',
  FETCH_CCS: 'CADMIN_PAGE_WALLET_FETCH_CCS',
  DELETE_CC: 'CADMIN_PAGE_WALLET_DELETE_CC',
  CREATE_CC: 'CADMIN_PAGE_WALLET_CREATE_CC',
  FETCH_BAS: 'CADMIN_PAGE_WALLET_FETCH_BAS',
  DELETE_BA: 'CADMIN_PAGE_WALLET_DELETE_BA',
  SHOW_ASSIGN_PM: 'CADMIN_PAGE_WALLET_SHOW_ASSIGN_PM',
  CLOSE_ASSIGN_PM: 'CADMIN_PAGE_WALLET_CLOSE_ASSIGN_PM',
  SUBMIT_ASSIGN_PM: 'CADMIN_PAGE_WALLET_SUBMIT_ASSIGN_PM',
  SHOW_BANK_ACCOUNT: 'CADMIN_PAGE_WALLET_SHOW_BANK_ACCOUNT',
};

const Actions = {

  load: ({params: {companySlug}}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(companySlug)),
      dispatch(Actions.fetchBankAccounts(companySlug)),
      dispatch(Actions.fetchCreditCards(companySlug)),
    ]);
    return dispatch({type: Types.LOAD, promise});
  },

  loadPageUpcomingCharges: ({params: {companySlug}}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(companySlug)),
      dispatch(CadminWalletAx.getUpcomingCharges(companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_UPCOMING_CHARGES, promise});
  },

  fetchCreditCards: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminCreditCardsAx.fetch(companyId));
    return dispatch({type: Types.FETCH_CCS, promise});
  },

  deleteCreditCard: (creditCardId) => (dispatch, getState) => {
    const promise = dispatch(CadminCreditCardsAx.delete(creditCardId));
    promise.then(() => {
      dispatch(Actions.fetchCreditCards());
      dispatch(ToastAx.success('Credit card deleted.'));
    });
    return dispatch({type: Types.DELETE_CC, promise, creditCardId});
  },

  createCc: (cardElement) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminCreditCardsAx.create(companyId, cardElement));
    promise.then(({creditCard}) => {
      dispatch(Actions.showAssignPm(creditCard.type, creditCard.id));
    });
    return dispatch({type: Types.CREATE_CC, promise});
  },

  fetchBankAccounts: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminBankAccountsAx.fetch(companyId));
    return dispatch({type: Types.FETCH_BAS, promise});
  },

  deleteBankAccount: (bankAccountId) => (dispatch, getState) => {
    const promise = dispatch(CadminBankAccountsAx.delete(bankAccountId));
    promise.then(() => {
      dispatch(Actions.fetchBankAccounts());
      dispatch(ToastAx.success('Bank account deleted.'));
    });
    return dispatch({type: Types.DELETE_BA, promise, bankAccountId});
  },

  showAssignPm: (pmType, pmId) => (dispatch, getState) => {
    return dispatch({type: Types.SHOW_ASSIGN_PM, pmType, pmId});
  },

  closeAssignPm: () => (dispatch, getState) => {
    return dispatch({type: Types.CLOSE_ASSIGN_PM});
  },

  submitAssignPm: (attrs) => (dispatch, getState) => {
    const promise = dispatch(CadminCompaniesAx.update(undefined, attrs));
    promise.then(() => {
      dispatch(ToastAx.success('Payment method has been assigned.'));
    });
    return dispatch({type: Types.SUBMIT_ASSIGN_PM, promise});
  },

  showBankAccount: (baId) => {
    return {type: Types.SHOW_BANK_ACCOUNT, baId};    
  },

};

export {
  Types,
};

export default Actions;
